import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";
import styles from "./styles.module.css";
import { useContext, useEffect, useRef, useState } from "react";
import {
  aprovarCadastro,
  buscarDadosAssociado,
  buscarDadosCliente,
  buscarDadosParceiro,
  buscarTimelineSolicitacao,
  downloadArquivos,
  downloadTodosArquivos,
  reprovarCadastro,
  verificarPermissaoAprovacao,
} from "../../../services/api-planejamento-tributario.service";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import SendIcon from "@mui/icons-material/Send";
import PaidIcon from "@mui/icons-material/Paid";
import MensagemErro from "../../../components/MensagemErro";
import MensagemSucesso from "../../../components/MensagemSucesso";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import { LoginContext } from "../../../config/Context/LoginContext";
import { usePermissoes, CHAVES_JURIDICO_EXPORT } from "../../../config/Context/PermissoesContext";
import { enviarNotificacao } from "../../../utils/webSocket.util";
import generatePDF from "react-to-pdf";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useNavigate } from "react-router-dom";
import HistoricoTimeline from "../HistoricoTimeline";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import ModalTimeLine from "../../../components/ModalTimeline";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import AnexoContrato from "../../AnexoContrato";
import axios from "axios";
import config from "../../../config";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";

const textoJustificativa = `Agradecemos o seu interesse, mas no momento não conseguimos te ajudar.
Entraremos em contato caso apareçam novas oportunidades.`;

const ModalVisualizar = ({ open, onClose, dadosUsuarios, atualizarDados }) => {
  const { pode } = usePermissoes();
  const podeExportar = pode(CHAVES_JURIDICO_EXPORT);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [openSnackErro, setOpenSnackErro] = useState(false);
  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [openConfirmAprov, setOpenConfirmAprov] = useState(false);
  const [openRecusaAprov, setOpenRecusaAprov] = useState(false);
  const [aprovacao, setAprovacao] = useState({ id: "", perfil: "" });
  const [optionsRecusa, setOptionsRecusa] = useState([]);
  const [dadosRecusa, setDadosRecusa] = useState({
    justificativa: "",
    criterioJuridico: "false",
    campos: [],
  });
  const { dadosLogin } = useContext(LoginContext);
  const [dadosModal, setDadosModal] = useState({ mensagem: "", funcao: "" });
  const [dadosComplementares, setDadosComplementares] = useState(false);
  const formRef = useRef();
  const minDesktop = useMediaQuery("(max-width: 426px)");
  const navigate = useNavigate();
  const historico = useRef(null);
  const [destaqHistory, setDestaqHistory] = useState(false);
  const [timeline, setTimeline] = useState([]);
  const [openTimeline, setOpenTimeline] = useState(false);
  const [podeAprovar, setPodeAprovar] = useState(false);
  const [openContrato, setOpenContrato] = useState(false);
  const [openConfirmContrato, setOpenConfirmContrato] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      handleCombos();
      aprovacao.id = dadosUsuarios.id;
      dadosUsuarios?.tipo
        ? (aprovacao.perfil = dadosUsuarios.tipo[0])
        : (aprovacao.perfil = "");
      setAprovacao({
        id: dadosUsuarios.id,
        perfil: dadosUsuarios?.tipo ? dadosUsuarios.tipo[0] : "",
      });
      let dados = "";

      try {
        switch (dadosUsuarios.tipo) {
          case "Parceiro":
            setDadosComplementares(true);
            {
              const responseP = await buscarDadosParceiro(dadosUsuarios.id);
              const listaUsuarios = responseP.data.dadosParceiro.idPai
                ? [
                    responseP.data.dadosParceiro.idUsuario,
                    responseP.data.dadosParceiro.idPai,
                  ]
                : [responseP.data.dadosParceiro.idUsuario];
              const { dadosParceiro, procurador, ...restP } = responseP.data;
              const newResponseP = {
                ...restP,
                dados: dadosParceiro,
                dadosProcurador: procurador,
                listaUsuarios,
              };
              dados = newResponseP;
            }
            break;
          case "Associado":
            setDadosComplementares(true);
            {
              const responseA = await buscarDadosAssociado(dadosUsuarios.id);
              const listaUsuarios = [responseA.data.dadosAssociado.idUsuario];
              const { dadosAssociado, procurador, ...restA } = responseA.data;
              const newResponseA = {
                ...restA,
                dados: dadosAssociado,
                dadosProcurador: procurador,
                listaUsuarios,
              };
              dados = newResponseA;
            }
            break;
          case "Cliente":
            setDadosComplementares(false);
            const responseC = await buscarDadosCliente(dadosUsuarios.id);
            const listaUsuarios = responseC.clientes[0].dadosCliente
              ?.idAssociadoPai
              ? [responseC.clientes[0].dadosCliente?.idAssociadoPai]
              : [responseC.clientes[0].dadosCliente?.idParceiroPai];
            const { dadosCliente, ...restC } = responseC.clientes[0];
            const newResponseC = {
              ...restC,
              dados: dadosCliente,
              listaUsuarios,
            };
            dados = newResponseC;
            break;
          default:
            break;
        }
        if (dados.dados) {
          if (dados.dados.idSolicitacaoAtual) {
            const permissao = await verificarPermissaoAprovacao(
              dados.dados.idSolicitacaoAtual
            );
            setPodeAprovar(permissao.podeAprovar);
          }
        }
        setData(dados);
      } catch (error) {
        setMsg(error.response.data.mensagem);
        setOpenSnackErro(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dadosUsuarios]);

  useEffect(() => {
    setDadosRecusa({
      ...dadosRecusa,
      justificativa:
        dadosRecusa.criterioJuridico === "true" ? textoJustificativa : "",
    });
  }, [dadosRecusa.criterioJuridico]);

  const getTargetElement = () => formRef.current;

  const handleExportPdf = async () => {
    const options = {
      filename: `${data.dados.nome}.pdf`,
      page: {
        margin: 10,
      },
    };
    generatePDF(getTargetElement, options);
  };

  const handleCombos = async () => {
    const comboRecusa = await buscarComboPorCodigo("CAMPOSFORMCADASTRO");
    const comboMap = comboRecusa.detalhes.itensCombo.map((item) => {
      const split = item.split("/|/");
      const novoItem = {
        id: split[0],
        cod: split[1],
        label: split[2],
      };
      return novoItem;
    });

    setOptionsRecusa(comboMap);
  };

  const handleBuscarTimeline = async () => {
    try {
      const response = await buscarTimelineSolicitacao(
        data.dados.idSolicitacaoAtual
      );
      setTimeline(response);
      setOpenTimeline(true);
    } catch (error) {
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const handleEnviarContrato = () => {
    setOpenContrato(true);
    onClose();
  };

  const handleAprovarCadastro = async () => {
    try {
      const responseTimeline = await buscarTimelineSolicitacao(
        data.dados.idSolicitacaoAtual
      );

      const isLast =
        responseTimeline[responseTimeline.length - 1].status === "PENDENTE";

      await aprovarCadastro({
        ...aprovacao,
        nome: data.dados.nome,
        listaUsuarios: data.listaUsuarios,
        idSolicitacao: data.dados.idSolicitacaoAtual,
      });
      await atualizarDados();
      setMsg("Aprovação realizada com sucesso!");
      setOpenSnackSucesso(true);
      handleCloseConfirmAprov();

      if (isLast) {
        await enviarNotificacao({
          titulo: `Cadastro Aprovado!`,
          texto: `O cadastro do ${dadosUsuarios.tipo} ${data.dados.nome} foi aprovado com sucesso!`,
          usuarios: data.listaUsuarios,
          path: `/`,
          tipo: "SUCESS",
        });
        if (dadosUsuarios.tipo === "Cliente") {
          handleCloseConfirmAprov();
          handleCloseRecusaAprov();
          await atualizarDados();
          onClose();
        } else {
          setOpenConfirmContrato(true);
        }
      }
    } catch (error) {
      setMsg(error.response.data.mensagem);
      // console.log(error);

      setOpenSnackErro(true);
    }
  };

  const handleReprovar = async (criterio) => {
    const dados = dadosRecusa.campos.map((item) => ({
      campo: item.label,
      codCampo: item.cod,
    }));

    const contentHistorico = { tipoHistorico: "Alteração solicitada", dados };

    try {
      await reprovarCadastro({
        ...dadosRecusa,
        tipo: dadosUsuarios.tipo[0],
        idUsuario: dadosUsuarios.id,
        usuCadastro: dadosLogin.idUsuario,
        nome: data.dados.nome,
        listaUsuarios: data.listaUsuarios,
        contentHistorico: JSON.stringify(contentHistorico),
        criterioJuridico: criterio,
        idSolicitacao: data.dados.idSolicitacaoAtual,
      });
      await enviarNotificacao({
        titulo: criterio ? `Cadastro Reprovado!` : "Corrigir Cadastro!",
        texto: criterio
          ? `O cadastro do ${dadosUsuarios.tipo} ${data.dados.nome} foi reprovado!`
          : `Clique aqui para corrigir o cadastro do ${dadosUsuarios.tipo} ${data.dados.nome}.`,
        usuarios: data.listaUsuarios,
        path: criterio
          ? "/"
          : `/editar-dados-candidato${
              dadosUsuarios.tipo[0] === "C"
                ? `?idCliente=${dadosUsuarios.id}`
                : ""
            }`,
        tipo: criterio ? "ALERT" : "WARNING",
      });

      atualizarDados();
      setMsg(`Usuário ${criterio ? `reprovado` : "requisitado"} com sucesso!`);
      setOpenSnackSucesso(true);
      handleCloseConfirmAprov();
      handleCloseRecusaAprov();
      await atualizarDados();
      onClose();
    } catch (error) {
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };
  const handleRecusarCadastro = async () => {
    if (dadosRecusa.justificativa !== "" && dadosRecusa.campos.length !== 0) {
      handleReprovar(false);
    } else {
      handleCloseConfirmAprov();
      setMsg(
        "Para prosseguir, necessário adicionar uma justificativa e informar os campos necessários de ajuste."
      );
      setOpenSnackErro(true);
    }
  };

  const handleChangeRecusa = (e) => {
    const { name, value } = e.target;
    setDadosRecusa({ ...dadosRecusa, [name]: value });
  };

  const handleChangeAutoCompleteRecusa = (_, value) => {
    setDadosRecusa({ ...dadosRecusa, campos: value });
  };

  const handleCloseTimeline = () => {
    setOpenTimeline(false);
  };

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };

  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const handleOpenConfirmAprov = (mensagem, funcao) => {
    setDadosModal({ mensagem, funcao });
    setOpenConfirmAprov(true);
  };

  const handleCloseConfirmAprov = () => {
    setOpenConfirmAprov(false);
  };

  const handleOpenRecusaAprov = () => {
    setDadosRecusa({ ...dadosRecusa, criterioJuridico: "false" });
    setOpenRecusaAprov(true);
  };

  const handleCloseRecusaAprov = () => {
    setOpenRecusaAprov(false);
    setDadosRecusa({
      justificativa: "",
      criterioJuridico: "false",
      campos: [],
    });
  };

  const handleCloseAll = async () => {
    await atualizarDados();
    handleCloseConfirmAprov();
    handleCloseRecusaAprov();
    onClose();
    setOpenConfirmContrato(false);
  };

  const handleDownload = async (arquivo) => {
    const response = await downloadArquivos(
      data.dados.id,
      arquivo,
      dadosUsuarios.tipo.toLowerCase()
    );
    if (response.data.file) {
      const contentUint8Array = new Uint8Array(response.data.file.data);
      const blob = new Blob([contentUint8Array], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      setMsg("Arquivo inexistente!");
      setOpenSnackErro(true);
    }
  };

  const handleDownloadAll = async () => {
    try {
      //Este caso específico é feito aqui devido as configurações de responseType e headers
      // que até o momento não compensaria criar uma service inteira para apenas 1 endpoint.
      const response = await axios.get(
        `${config.REACT_APP_HOST_API_PLANEJAMENTO_TRIBUTARIO}/downloadAll?id=${
          data.dados.id
        }&tipoCadastro=${dadosUsuarios.tipo.toLowerCase()}`,
        {
          responseType: "blob",
          headers: {
            Accept: "application/zip",
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `${data ? data.dados.nome : "ARQUIVOS"}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar os arquivos:", error);
      setMsg("Erro ao baixar arquivos! Contate a equipe técnica.");
      setOpenSnackErro(true);
    }
  };

  const handleHistorico = () => {
    setDestaqHistory(true);
    setTimeout(() => {
      if (historico.current) {
        historico.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 300);
  };

  return (
    <>
      {!loading ? (
        <Dialog
          open={open}
          onClose={() => {
            setDestaqHistory(false);
            onClose();
          }}
          maxWidth="lg"
        >
          <DialogTitle className={styles.container_title}>
            {dadosUsuarios.status === "N" ? (
              <h3 className={styles.title}>
                <PaidIcon sx={{ marginRight: ".5rem" }} /> Negociação
              </h3>
            ) : (
              <h3 className={styles.title}>
                <AssignmentIndIcon sx={{ marginRight: ".5rem" }} /> Informações
                Cadastradas
              </h3>
            )}
            <div className={styles.btnTopContainer}>
              {data?.dados?.idSolicitacaoAtual ? (
                <Button
                  variant="outlined"
                  onClick={handleBuscarTimeline}
                  color="warning"
                >
                  <AltRouteIcon sx={{ marginX: minDesktop ? ".5rem" : "" }} />
                  {minDesktop ? "" : "FLUXO DE APROVAÇÃO"}
                </Button>
              ) : (
                ""
              )}
              <Button variant="outlined" onClick={handleHistorico} color="info">
                <HistoryIcon sx={{ marginX: minDesktop ? ".5rem" : "" }} />
                {minDesktop ? "" : "HISTÓRICO"}
              </Button>
              {podeExportar && (
                <Button
                  variant="outlined"
                  onClick={handleExportPdf}
                  color="error"
                >
                  <PictureAsPdfIcon sx={{ marginX: minDesktop ? ".5rem" : "" }} />
                  {minDesktop ? "" : "EXPORTAR"}
                </Button>
              )}
            </div>
          </DialogTitle>
          <DialogContent>
            <div ref={formRef}>
              <Grid container spacing={2} sx={{ marginTop: "1rem" }}>
                <Grid item xs={12} sm={4}>
                  {data ? (
                    data.dados.nomeUsuarioPai ? (
                      <TextField
                        size="small"
                        label={
                          dadosUsuarios.tipo === "Cliente"
                            ? data.dados.idAssociadoPai
                              ? "Associado Responsável"
                              : "Parceiro Responsável"
                            : "Associado Responsável"
                        }
                        fullWidth
                        disabled
                        value={data ? data.dados.nomeUsuarioPai : null}
                      />
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    1 - Dados do Cliente
                  </h4>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    disabled
                    value={data ? data.dados.nome : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={2}>
                  <TextField
                    size="small"
                    label="CEP"
                    fullWidth
                    value={data ? data.dados.cep : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={5} md={6}>
                  <TextField
                    size="small"
                    label="Logradouro"
                    fullWidth
                    value={data ? data.dados.logradouro : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2} md={3}>
                  <TextField
                    size="small"
                    label="Bairro"
                    fullWidth
                    value={data ? data.dados.bairro : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2}>
                  <TextField
                    size="small"
                    label="Número"
                    fullWidth
                    value={data ? data.dados.numero : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <TextField
                    size="small"
                    label="Complemento"
                    fullWidth
                    value={data ? data.dados.complemento : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2} md={3}>
                  <TextField
                    size="small"
                    label="Cidade"
                    fullWidth
                    value={data ? data.dados.cidade : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2} md={1}>
                  <TextField
                    size="small"
                    label="Estado"
                    fullWidth
                    value={data ? data.dados.estado : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={2} md={1}>
                  <TextField
                    size="small"
                    label="Pais"
                    fullWidth
                    value={data ? data.dados.pais : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.dados.cpf : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={5}>
                  <TextField
                    size="small"
                    label="E-mail"
                    value={data ? data.dados.email : null}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.dados.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.dados.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    2 - Responsável pela Empresa
                  </h4>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Nome"
                    value={data ? data.responsavelEmpresa.nome : null}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Profissão"
                    fullWidth
                    value={data ? data.responsavelEmpresa.profissao : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={5} sm={2}>
                  <FormControl>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{ fontSize: "0.8rem" }}
                    >
                      Estrangeiro?
                    </FormLabel>
                    <h5 style={{ margin: 0, color: "gray" }}>
                      {data ? data.responsavelEmpresa.estrangeiro : null}
                    </h5>
                  </FormControl>
                </Grid>

                <Grid item xs={7} sm={2}>
                  <TextField
                    size="small"
                    label="Tipo Documento"
                    value={data ? data.responsavelEmpresa.tipoDocumento : null}
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="Documento"
                    fullWidth
                    value={data ? data.responsavelEmpresa.documento : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Ramo de atividade"
                    fullWidth
                    value={data ? data.responsavelEmpresa.ramo : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="E-mail"
                    type="email"
                    value={data ? data.responsavelEmpresa.email : null}
                    disabled
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="NºOAB"
                    disabled
                    fullWidth
                    value={data ? data.responsavelEmpresa.oab : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="CRC"
                    fullWidth
                    value={data ? data.responsavelEmpresa.crc : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.responsavelEmpresa.telefone : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.responsavelEmpresa.whatsapp : null}
                    disabled
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{ fontSize: "0.8rem" }}
                    >
                      Alguém te Indicou?
                    </FormLabel>
                    <h5 style={{ margin: 0, color: "gray" }}>
                      {data ? data.responsavelEmpresa.foiIndicado : null}
                    </h5>
                  </FormControl>
                </Grid>
                {data ? (
                  data.responsavelEmpresa.foiIndicado === "SIM" ? (
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="small"
                        label="Indicado Por..."
                        fullWidth
                        disabled
                        value={
                          data ? data.responsavelEmpresa.indicadoPor : null
                        }
                        style={
                          {
                            // display: foiIndicadoResponsavel ? "block" : "none",
                          }
                        }
                      />
                    </Grid>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    3 - Responsável Financeiro
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.nome : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="E-mail"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.email : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.cpf : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.responsavelFinanceiro.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    4 - Responsável Legal
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    value={data ? data.responsavelLegal.nome : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="E-mail"
                    fullWidth
                    value={data ? data.responsavelLegal.email : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.responsavelLegal.cpf : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.responsavelLegal.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.responsavelLegal.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    5 - Dados do Procurador
                  </h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="Nome"
                    fullWidth
                    value={data ? data.dadosProcurador.nome : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    size="small"
                    label="E-mail"
                    fullWidth
                    value={data ? data.dadosProcurador.email : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="CPF"
                    fullWidth
                    value={data ? data.dadosProcurador.cpf : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Telefone"
                    fullWidth
                    value={data ? data.dadosProcurador.telefone : null}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="WhatsApp"
                    fullWidth
                    value={data ? data.dadosProcurador.whatsapp : null}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                <Grid item xs={12} sm={12}>
                  <h4 className={styles.titulosConfirmacao}>
                    6 - Dados Bancários
                  </h4>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    label="Banco"
                    fullWidth
                    value={data ? data.dadosBancarios.banco : null}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    size="small"
                    label="Agência"
                    fullWidth
                    disabled
                    value={data ? data.dadosBancarios.agencia : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="Conta"
                    fullWidth
                    disabled
                    value={data ? data.dadosBancarios.conta : null}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    size="small"
                    label="PIX"
                    value={data ? data.dadosBancarios.pix : null}
                    fullWidth
                    disabled
                  />
                </Grid>
              </Grid>

              {dadosComplementares && (
                <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                  <Grid item xs={12} sm={12}>
                    <h4 className={styles.titulosConfirmacao}>
                      7 - Dados Complementares
                    </h4>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      value={data ? data.dadosComplementares.motivacao : null}
                      disabled
                      multiline
                      maxRows={6}
                      label="Motivação do candidato"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      value={
                        data ? data.dadosComplementares.tiposNegocio : null
                      }
                      disabled
                      multiline
                      maxRows={5}
                      label="Tipos de Negócio"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      size="small"
                      value={
                        data
                          ? (data.dadosComplementares.contraproposta ?? "15") +
                            "%"
                          : null
                      }
                      fullWidth
                      disabled
                      label="Comissionamento"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      value={data ? data.dadosComplementares.observacao : null}
                      disabled
                      multiline
                      maxRows={6}
                      label="Observação"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              )}
            </div>
            <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={12} sm={12}>
                <h4 className={styles.titulosConfirmacao}>
                  8 - Anexo de Documentos
                  <Button
                    variant="outlined"
                    endIcon={<CloudDownloadIcon />}
                    className={styles.btnDownloadAll}
                    onClick={handleDownloadAll}
                  >
                    Baixar todos
                  </Button>
                </h4>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("rg")}
                >
                  <CloudDownloadIcon />
                  <span> RG</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("cpf")}
                >
                  <CloudDownloadIcon />
                  <span> CPF</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("comprovante_residencia")}
                >
                  <CloudDownloadIcon />
                  <span> Comp. Residência</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("passaporte")}
                >
                  <CloudDownloadIcon />
                  <span> Passaporte</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("rne")}
                >
                  <CloudDownloadIcon />
                  <span> RNE</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("cpf_socios")}
                >
                  <CloudDownloadIcon />
                  <span> CPF dos Sócios</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() =>
                    handleDownload("comprovante_residencia_socios")
                  }
                >
                  <CloudDownloadIcon />
                  <span> Comp. Residência Sócios</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() =>
                    handleDownload("comprovante_residencia_empresa")
                  }
                >
                  <CloudDownloadIcon />
                  <span> Comp. Residência Empresa</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("contrato_social")}
                >
                  <CloudDownloadIcon />
                  <span> Contrato Social</span>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className={styles.btnContainer}>
                <Button
                  className={styles.btnDownload}
                  onClick={() => handleDownload("cartao_cnpj")}
                >
                  <CloudDownloadIcon />
                  <span> Cartão CNPJ</span>
                </Button>
              </Grid>
              {dadosUsuarios.tipo !== "Cliente" ? (
                <>
                  <Grid item xs={12} sm={6} className={styles.btnContainer}>
                    <Button
                      className={styles.btnDownload}
                      onClick={() => handleDownload("crc")}
                    >
                      <CloudDownloadIcon />
                      <span> CRC</span>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} className={styles.btnContainer}>
                    <Button
                      className={styles.btnDownload}
                      onClick={() => handleDownload("oab")}
                    >
                      <CloudDownloadIcon />
                      <span> OAB</span>
                    </Button>
                  </Grid>
                </>
              ) : (
                ""
              )}
            </Grid>
            <div ref={historico}>
              <HistoricoTimeline
                destaque={destaqHistory}
                tipoCadastro={dadosUsuarios.tipo}
                idUsuario={dadosUsuarios.id}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={{ sm: 1, xs: 1 }}>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setDestaqHistory(false);
                    onClose();
                    navigate("/juridico/proponentes");
                  }}
                  className={styles.btnFechar}
                  fullWidth
                >
                  Fechar
                </Button>
              </Grid>
              {dadosUsuarios.status === "N" && podeAprovar ? (
                <>
                  {minDesktop ? "" : <Grid item xs={0} sm={4}></Grid>}
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<CloseIcon />}
                      onClick={async () => {
                        setDadosRecusa({
                          ...dadosRecusa,
                          criterioJuridico: "true",
                        });
                        handleOpenConfirmAprov("reprovando", () =>
                          handleReprovar(true)
                        );
                      }}
                      fullWidth
                      className={styles.divBtnReprovar}
                    >
                      REPROVAR
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="outlined"
                      color="warning"
                      startIcon={<EditIcon />}
                      onClick={handleOpenRecusaAprov}
                      fullWidth
                      className={styles.divBtnReprovar}
                    >
                      REQUISITAR
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="contained"
                      color="success"
                      startIcon={<CheckIcon />}
                      onClick={() =>
                        handleOpenConfirmAprov("aprovando", () =>
                          handleAprovarCadastro()
                        )
                      }
                      fullWidth
                    >
                      APROVAR
                    </Button>
                  </Grid>
                </>
              ) : (
                <div />
              )}
            </Grid>
          </DialogActions>
        </Dialog>
      ) : (
        ""
      )}

      {/* MODAL DE CONFIRMAÇÃO DE ENVIO DE CONTRATO */}
      <Dialog
        open={openConfirmContrato}
        onClose={() => setOpenConfirmContrato(false)}
      >
        <DialogContent className={styles.dialogConfirm}>
          <h2 className={styles.titleConfirmContrato}>
            <HistoryEduIcon /> Enviar Contrato
          </h2>
          Você deseja enviar o <strong>contrato</strong> do proponente{" "}
          <strong>agora</strong>?
          <div>
            <Button
              variant="outlined"
              startIcon={<AccessTimeIcon />}
              sx={{ marginRight: ".5rem" }}
              className={styles.notConfirmContrato}
              onClick={() => {
                setOpenConfirmContrato(false);
                onClose();
              }}
            >
              ENVIAR MAIS TARDE
            </Button>
            <Button
              variant="contained"
              startIcon={<UploadFileIcon />}
              onClick={handleEnviarContrato}
              className={styles.yesConfirmContrato}
            >
              ENVIAR AGORA
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* MODAL DE APROVAR */}
      <Dialog open={openConfirmAprov} onClose={handleCloseConfirmAprov}>
        <DialogContent className={styles.dialogConfirm}>
          Você está {dadosModal.mensagem} o candidato{" "}
          <strong>{data && data.dados.nome}</strong>. <br /> Deseja{" "}
          <strong>realmente</strong> fazer isso?
          <div>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              sx={{ marginRight: ".5rem" }}
              className={styles.nao}
              onClick={handleCloseConfirmAprov}
            >
              NÃO
            </Button>
            <Button
              variant="contained"
              startIcon={<CheckIcon />}
              onClick={dadosModal.funcao}
              className={styles.sim}
            >
              SIM
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* MODAL DE REQUISITAR */}
      <Dialog open={openRecusaAprov} onClose={handleCloseRecusaAprov} fullWidth>
        <DialogContent>
          <span className={styles.titleRecusa}>
            Justifique o motivo da requisição.
          </span>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                label="Justificativa"
                variant="outlined"
                name="justificativa"
                value={dadosRecusa.justificativa}
                onChange={handleChangeRecusa}
                fullWidth
                multiline
                rows={6}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={optionsRecusa}
                getOptionLabel={(option) => option.label}
                filterSelectedOptions
                onChange={handleChangeAutoCompleteRecusa}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Campos Inválidos"
                    // placeholder="Favorites"
                  />
                )}
              />
            </Grid>
          </Grid>
          <div className={styles.botoesRecusa}>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              sx={{ marginRight: ".5rem" }}
              className={styles.nao}
              onClick={handleCloseRecusaAprov}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              startIcon={<SendIcon />}
              onClick={() =>
                handleOpenConfirmAprov("retornando para edição", () =>
                  handleRecusarCadastro()
                )
              }
              className={styles.sim}
            >
              Enviar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
      <ModalTimeLine
        onClose={handleCloseTimeline}
        open={openTimeline}
        timeline={timeline}
      />
      <AnexoContrato
        open={openContrato}
        setOpen={setOpenContrato}
        dadosUsuario={{ ...data, tipoUsuario: dadosUsuarios?.tipo }}
        handleCloseAll={handleCloseAll}
      />
    </>
  );
};

export default ModalVisualizar;
